import clsx from 'clsx'
import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  LabelHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react'
import { Controller, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { InputTextProps } from '../input-text/input-text'

export interface TextAreaProps<T extends FieldValues>
  extends InputTextProps<T> {
  containerProps?: DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
  labelProps?: DetailedHTMLProps<
    LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >
  textAreaProps?: Omit<
    DetailedHTMLProps<
      TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >,
    'name' | 'rules'
  >
  label?: string
  customLabel?: JSX.Element
  placeholder?: string
  disabled?: boolean
}

function TextArea<T extends FieldValues>({
  control,
  label,
  customLabel,
  name,
  rules,
  containerProps,
  textAreaProps,
  labelProps,
  placeholder,
  disabled = false,
}: TextAreaProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const classes = clsx(s.form_control, containerProps?.className, {
          [s.is_error]: error,
        })
        return (
          <div className={classes} {...containerProps}>
            <div className={s.labelContainer}>
              {label && <label {...labelProps}>{label}</label>}
              {customLabel}
              {error && error.message && (
                <span className={s.form__error}>{error.message}</span>
              )}
            </div>
            <textarea
              {...field}
              {...textAreaProps}
              placeholder={placeholder}
              disabled={disabled}
              className={clsx(s.textarea, textAreaProps?.className)}
            />
          </div>
        )
      }}
    />
  )
}

export { TextArea }
